const STORAGE_KEY = 'LS_consentActions';

const getConsentActions = (exports.getConsentActions = () => {
  let consentActions;
  try {
    consentActions = JSON.parse(window.localStorage.getItem(STORAGE_KEY)) || {};
  } catch (e) {
    consentActions = {};
  }
  return consentActions;
});

exports.storeConsentAction = (type, selection, version) => {
  const consentActions = getConsentActions();
  consentActions[type] = { selection, version };
  window.localStorage.setItem(STORAGE_KEY, JSON.stringify(consentActions));
};

exports.clearConsentActions = () => {
  window.localStorage.removeItem(STORAGE_KEY);
};
